;(function ($) { $.fn.datepicker.language['nl'] = {
    days: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
    daysShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
    daysMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
    months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    today: 'Vandaag',
    clear: 'Legen',
    dateFormat: 'dd-MM-yy',
    timeFormat: 'hh:ii',
    firstDay: 0
}; })(jQuery);


//////////////////
// WEBPACK FOOTER
// ./node_modules/air-datepicker/dist/js/i18n/datepicker.nl.js
// module id = 9
// module chunks = 0